import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Flex, FormControl, FormLabel, Heading, Input, InputGroup, InputRightElement, Text, useColorModeValue } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { adminLogin } from "../../../redux/actions/Admin.action";
import { toast } from "react-toastify";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import illustration from "assets/img/mizzo.jpg";
import logo from "assets/img/zokep-edit.png";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";

function SignIn() {
  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = "gray.400";
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const adminData = useSelector((state) => state.admin)

  const token = adminData?.LoginAdmin?.data?.user?.token;
  const type = adminData?.LoginAdmin?.data?.user?.type;

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email('Invalid email format')
      .required('Email is required'),
    password: Yup.string().required('password is required'),
  });

  const handleSubmit = (values) => {
    setLoader(true);
    const payload = { email: values.email, password: values.password };
    dispatch(adminLogin(payload))
      .then((res) => {
        if (res?.data?.status === 200) {
          console.log("adminData?.LoginAdmin?.data", res);

          setLoader(false);
          if (res?.data?.user?.type === 'Admin') {
            navigate('/master/masterDashboard');
            window.location.reload();
          }
          else if (res?.data?.user?.type === 'Admin2') {
            navigate('/master/masterDashboard');
            window.location.reload();
          }
          else if (res?.data?.user?.type === 'Manager') {
            navigate('/master/masterDashboard');
            window.location.reload();
          }
          else if (res?.data?.user?.type === 'SuperAdmin') {
            navigate('/superAdmin/dashboard');
            window.location.reload();
          }
          else if (res?.data?.user?.type === 'SuperAdmin2') {
            navigate('/superAdmin/dashboard');
            window.location.reload();
          }
        } else if (res?.data?.status === 404) {
          toast.error("Admin is not authenticated!");
          setLoader(false);
        } else if (res?.data?.status === 200 && !token) {
          toast.error("Admin is not authenticated!");
          setLoader(false);
        } else if (res?.data?.status === 401) {
          toast.error("Password Invalid");
          setLoader(false);
        } else if (res?.data?.status === 403) {
          toast.error(res?.data?.message);
          setLoader(false);
        }

      })
      .catch(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    // if (adminData?.LoginAdmin?.data?.status === 200 && token) {
    //   console.log("adminData?.LoginAdmin?.data", adminData?.LoginAdmin?.data);

    //   setLoader(false);
    //   if (type === 'Master') {
    //     navigate('/master/materDashboard');
    //     window.location.reload();
    //   }
    //   else if (type === 'Doctor') {
    //     navigate('/doctor/doctorDashboard');
    //     window.location.reload();
    //   }
    //   else if (type === 'Counselors') {
    //     navigate('/counselor/counselorDashboard');
    //     window.location.reload();
    //   }
    //   else if (type === 'Therapist') {
    //     navigate('/therapist/therapistDashboard');
    //     window.location.reload();
    //   }
    //   else {
    //     navigate('/master/masterDashboard');
    //     window.location.reload();
    //   }
    // } else if (adminData?.LoginAdmin?.status === 404) {
    //   toast.error("Admin is not authenticated!");
    //   setLoader(false);
    // } else if (adminData?.LoginAdmin?.status === 200 && !token) {
    //   toast.error("Admin is not authenticated!");
    //   setLoader(false);
    // } else if (adminData?.LoginAdmin?.status === 401) {
    //   toast.error("Password Invalid");
    //   setLoader(false);
    // }

  }, [adminData, navigate, token]);

  return (
    <>
      {loader && (
        <div className="loaderAdd">
          <div className="loader_line"><img src={logo} className="w-[200px]" /></div>
        </div>
      )}
      <div className={`min-h-screen row justify-content-center align-items-center`}>
        {/* <div className=""> */}
          <Flex
            maxW={{ base: "100%", md: "max-content" }}
            w='100%'
            mx='auto'
            h='100%'
            alignItems='center'
            justifyContent='center'
            mb={{ base: "30px", md: "60px" }}
            px={{ base: "25px", md: "0px" }}
            flexDirection='column'>
            <Box me='auto'>
              <div>
                <img src={logo} className="w-[200px] " />
              </div>
              <Heading color={textColor} fontSize='36px' mb='10px'>
                Sign In
              </Heading>
              {/* <Text
                className="mb-5"
                ms='4px'
                color={textColorSecondary}
                fontWeight='400'
                fontSize='md'>
                Enter your email
              </Text> */}
            </Box>
            <Flex
              zIndex='2'
              direction='column'
              w={{ base: "100%", md: "420px" }}
              maxW='100%'
              background='transparent'
              borderRadius='15px'
              mx={{ base: "auto", lg: "unset" }}
              me='auto'
              mb={{ base: "20px", md: "auto" }}>

              <Formik
                initialValues={{ email: '', otp: '' }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                  handleSubmit(values);
                }}
              >
                {({ values, handleChange, handleBlur, handleSubmit, isSubmitting, touched }) => (
                  <Form onSubmit={handleSubmit}>
                    <FormControl>
                      <FormLabel
                        display='flex'
                        ms='4px'
                        fontSize='sm'
                        fontWeight='500'
                        color={textColor}
                        mb='8px'>
                        Email<Text style={{ color: '#F5EAD5' }}>*</Text>
                      </FormLabel>
                      <Field
                        as={Input}
                        name="email"
                        variant='auth'
                        fontSize='sm'
                        ms={{ base: "0px", md: "0px" }}
                        type='email'
                        placeholder='Enter Email Id'
                        fontWeight='500'
                        size='lg'
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.email && <ErrorMessage name="email" component="div" style={{ color: 'red', marginTop: "5px" }} />}

                      {/* <FormLabel
                        ms='4px'
                        fontSize='sm'
                        fontWeight='500'
                        color={textColor}
                        display='flex'
                        alignItems={'center'}
                        mt='24px'
                      >
                        Password
                      </FormLabel>
                      <InputGroup size='md' className="relative">
                        <Field
                          as={Input}
                          name="password"
                          fontSize='sm'
                          placeholder='Enter Password'
                          size='lg'
                          type={show ? "text" : "password"}
                          variant='auth'
                          value={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <div className="absolute top-3 right-3" onClick={handleClick}>
                          {show ? <ViewIcon /> : <ViewOffIcon />} {/* Toggle between ViewIcon and ViewOffIcon
                        </div>
                      </InputGroup>
                      {touched.password && <ErrorMessage name="password" component="div" style={{ color: 'red', marginTop: "5px" }} />} */}
                      <>
                        {/* <FormLabel fontSize='sm' fontWeight='500' color={textColor} mt='24px'>
                            Password
                          </FormLabel>
                          <Field
                            as={Input}
                            name="password"
                            variant='auth'
                            fontSize='sm'
                            type="text"
                            placeholder='Enter Password'
                            size='lg'
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {touched.password && <ErrorMessage name="password" component="div" style={{ color: 'red', marginTop: "5px" }} />} */}
                        <FormLabel fontSize='sm' fontWeight='500' color={textColor} mt='24px'>
                          Password
                        </FormLabel>
                        <InputGroup size='md'>
                          <Field
                            as={Input}
                            name="password"
                            variant='auth'
                            fontSize='sm'
                            type={show ? "text" : "password"} // Toggle between text and password
                            placeholder='Enter Password'
                            size='lg'
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <InputRightElement width="4.5rem">
                            <Button
                              h="1.75rem"
                              size="sm"
                              bg="transparent" // Transparent background
                              _hover={{ bg: "transparent" }} // No hover background
                              _active={{ bg: "transparent" }} // No active background
                              onClick={handleClick}
                            >
                              {show ? <ViewOffIcon boxSize={5} /> : <ViewIcon boxSize={5} />} {/* Normal icon size */}
                            </Button>
                          </InputRightElement>
                        </InputGroup>
                        {touched.password && <ErrorMessage name="password" component="div" style={{ color: 'red', marginTop: "5px" }} />}
                      </>

                      <Button
                        fontSize='md'
                        variant='brand'
                        fontWeight='500'
                        w='100%'
                        h='50'
                        mb='24px'
                        mt='24px'
                        className="!bg-theme-dark"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {"Sign In"}
                      </Button>
                    </FormControl>
                    <div className="text-center">
                      <p><b>For Support:</b> <a href="mailto:zokepcrm@gmail.com" className="text-blue-950">zokepcrm@gmail.com</a></p>
                    </div>
                  </Form>
                )}
              </Formik>
            </Flex>
          </Flex>
        {/* </div> */}
       
      </div>
    </>
  );
}

export default SignIn;